wbApp.directive('wbFullStudentEdit', ['$timeout', '$translate', '$q', '$http', 'tenantSettingSvc',
    function ($timeout, $translate, $q, $http, tenantSettingSvc) {

        return {
            restrict: 'A',
            scope: {
                model: '=ngModel',
                adminEdit: '=',
                disabled: '=ngDisabled',
            },
            templateUrl: 'directives/forms/full-student-edit.html',
            controller: ['$scope', '$element', function ($scope, $element) {

                $scope.typeAheadAddress = [];
                $scope.tenantSetting = tenantSettingSvc.settings;

                $scope.getAddress = function (viewValue) {
                    if (viewValue) {
                        let params = {
                            address: viewValue,
                            language: 'cs',
                            region: 'cz',
                            bounds: '48.270777,12.172380|51.246709,19.922157', // Czech republic bounds
                            key: 'AIzaSyDdpRFWJaEcASaUgQxTdi8i42aaCaKfS0A'
                        };
                        return $http.get('https://maps.googleapis.com/maps/api/geocode/json', { params: params })
                            .then(function (res) {
                                $scope.typeAheadAddress.length = 0;
                                $scope.typeAheadAddress.push.apply($scope.typeAheadAddress, res.data.results);
                            });
                    }
                };
            }],

            link: function ($scope, $element, attrs, ctrl) {
            }
        }
    }]);